import { render } from "./InputWrapper.vue?vue&type=template&id=49ed9fa8&scoped=true"
import script from "./InputWrapper.vue?vue&type=script&lang=js"
export * from "./InputWrapper.vue?vue&type=script&lang=js"

import "./InputWrapper.vue?vue&type=style&index=0&id=49ed9fa8&lang=scss&scoped=true"
import "./InputWrapper.vue?vue&type=style&index=1&id=49ed9fa8&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ed9fa8"]])

export default __exports__